import { Component, EventEmitter, Output } from '@angular/core';
import { llamar } from '../../utils/phone.utils';

@Component({
	selector: 'cmv-call-btn',
	templateUrl: './call-btn.component.html',
	styleUrls: ['./call-btn.component.scss'],
})
export class CallBtnComponent {
	constructor() {}

	onClick(): void {
		llamar();
	}
}
